export default __webpack_public_path__ + "static/ublox-8dc19fa65a1da0fcb2e95a2037056463.svg";